var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "giveaway_box" }, [
    _c("div", { staticClass: "giveaway_name" }, [_vm._v("用户注册等级配置")]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "margin-top": "40px" } },
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            staticClass: "demo-ruleForm",
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.rules,
              "label-width": "100px",
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "选择等级", prop: "grade" } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: "用户等级", clearable: "" },
                    on: { change: _vm.onGradeChange },
                    model: {
                      value: _vm.ruleForm.grade,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "grade", $$v)
                      },
                      expression: "ruleForm.grade",
                    },
                  },
                  _vm._l(_vm.options, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.name, value: item.grade },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { color: "#f59a23" } }, [
                  _vm._v(
                    "\n          用户注册时成为的等级（默认选择初始等级）\n        "
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitForm("ruleForm")
                      },
                    },
                  },
                  [_vm._v("确认")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }